<script setup lang="ts">
import { ref,reactive,onMounted,watch } from 'vue'
import config from "../../config.js";
import { errorAlertApp } from "../../plugins/alert_app";
import ModalAppDialog from "../../compositions/ModalAppDialog.vue";
import CustomList from "../../compositions/CustomList.vue";
import SearchBox from "../../compositions/SearchBox.vue";
import TextBox from "../../compositions/TextBox.vue";
import CheckBox from "../../compositions/CheckBox.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import { getFieldValue } from "../../plugins/utility";
import { screenTransition,callBarcode,authCheck } from "../../plugins/flutter";
import { useAuditStore } from '../../stores/audit';
import { useDeliveryStore } from '../../stores/delivery';
import { useAppSettingStore } from '../../stores/app_setting';
import { useOrderStore } from '../../stores/order';
import { useAppStockStore } from '../../stores/app_stock';
import axios from '../../plugins/axios.ts';

const audit = useAuditStore();
const delivery = useDeliveryStore();
const appSetting = useAppSettingStore();
const order = useOrderStore();
const appStock = useAppStockStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    user:{
      type:Object,
      required:true,
    },
    staffs:{
      type:Array,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})

const callMenu = (menuName) => {
  screenTransition(menuName);
}
const callDeviceBarcord = (screenName,recordId,staffId,patientName='',hospitalName='') => {
  callBarcode(screenName,recordId,staffId,patientName,hospitalName);
  //画面表示が遅いため、数秒後変数初期化する
  setTimeout(initialParams,config.LIST_DELAY);
}
const spappMenu = ref('');
const isAuditCheckDialog = ref(false);
const isAuditCheckLoading = ref(false);
const searchPatientWord = ref('');
const listPatientRef = ref();
const prescriptId = ref(0);
const patientFields = ref([
  {field_name: '患者名', field_key: 'patient_profile.patient_kanji_name', width: '50%', align: 'text-left', sorted:false},
  {field_name: '来院日時', field_key: 'real_prescript_date', width: '50%', align: 'text-center', sorted:false},
]);
const patientOptionFields = reactive({
  'patient_name' : searchPatientWord.value,
  'page_size' : 15,
  'sort_desc' : 'real_prescript_date',
  'is_audit' : 1,
  'is_product_start_time': 1,
  'is_today' : appSetting.is_audit_today ? 1 : 0,
  'is_audit_range' : appSetting.is_audit_today ? 0 : 1,
});
const patientListRefresh = () => {
  patientOptionFields.patient_name = searchPatientWord.value;
  patientOptionFields.is_today = appSetting.is_audit_today ? 1 : 0;
  patientOptionFields.is_audit_range = appSetting.is_audit_today ? 0 : 1;

  listPatientRef.value.resetItem();
}
const onChangePatientWord = (value) => {
  searchPatientWord.value = value;
  patientListRefresh();
}
const onEnterPatientWord = (value) => {
  searchPatientWord.value = value;
  patientListRefresh();
}
const showAuditCheckDialog = () => {
  initialParams();
  patientListRefresh();
  isAuditCheckDialog.value = true;
}
const closeAuditCheckDialog = () => {
  isAuditCheckDialog.value = false;
  prescriptId.value = 0;
}
const selectAuditCheckPrescript = (selectPrescriptId,patientName,hospitalName) => {
  isAuditCheckLoading.value = true;
  prescriptId.value = selectPrescriptId;
  //バーコードリーダー起動
  callDeviceBarcord(config.SPAPP_MENU['監査チェック'],prescriptId.value,staffId.value,patientName,hospitalName);
}
const isStaffDialog = ref(false);
const isStaffLoading = ref(false);
const staffId = ref(0);
const showStaffDialog = (menuType) => {
  //storeの情報を消す
  audit.reset_data();
  delivery.reset_data();
  order.reset_data();
  appStock.reset_data();
  //検索条件をリセット
  searchDeliveryOrderWord.value = '';
  searchPatientWord.value = '';
  searchDeliveryOrderWord.value = '';
  deliveryActiveTab.value = 0;
  spappMenu.value = menuType;
  isStaffDialog.value = true;
}
const closeStaffDialog = () => {
  isStaffDialog.value = false;
}
const selectStaff = (selectStaffId) => {
  staffId.value = selectStaffId;
  closeStaffDialog();
  if (spappMenu.value == config.SPAPP_MENU['棚卸'] || spappMenu.value == config.SPAPP_MENU['発注']) {
    //バーコード画面起動
    callDeviceBarcord(spappMenu.value,0,staffId.value);
  } else if (spappMenu.value == config.SPAPP_MENU['監査チェック']) {
    showAuditCheckDialog();
  } else {
    showDeliveryOrderDialog();
  }
}
onMounted(() => {
  authCheck(props.user);
  initialParams();
});
const initialParams = () => {
  isStaffDialog.value = false;
  isAuditCheckDialog.value = false;
  isAuditCheckLoading.value = false;
  isDeliveryOrderDialog.value = false;
  isDeliveryOrderLoading.value = false;
  isDeliveryEstablishFileDialog.value = false;
  isDeliveryEstablishFileLoading.value = false;
  isMedicineGroupDialog.value = false;
}
/////////////////////////
// 発注先対応
/////////////////////////
const deliveryActiveTab = ref(0);
const deliveryActiveTabs = [
  {id:0,tab_name:"卸"},
  {id:1,tab_name:"小分け"},
]
const isDeliveryOrderDialog = ref(false);
const isDeliveryOrderLoading = ref(false);
const listDeliveryOrderStockRef = ref();
const listDeliveryOrderPackRef = ref();
const searchDeliveryOrderWord = ref('');
const deliveryOrderFields = ref([
  {field_name: '発注先', field_key: 'order_target', width: '50%', align: 'text-left', sorted:false},
]);
const deliveryOrderOptionStockFields = reactive({
  'search_word' : searchDeliveryOrderWord.value,
  'page_size' : 30,
  'is_wait' : 1,
  'stock_type': config.STOCK_TYPES['VAN'],
});
const deliveryOrderOptionPackFields = reactive({
  'search_word' : searchDeliveryOrderWord.value,
  'page_size' : 30,
  'is_wait' : 1,
  'stock_type': config.STOCK_TYPES['小分け'],
});

const deliveryListSearch = () => {
  if (deliveryActiveTab.value == 0) {
    deliveryOrderOptionStockFields.search_word = searchDeliveryOrderWord.value;
    listDeliveryOrderStockRef.value.resetItem();
  } else {
    deliveryOrderOptionPackFields.search_word = searchDeliveryOrderWord.value;
    listDeliveryOrderPackRef.value.resetItem();
  }
}
const onChangeDeliveryOrderWord = (value) => {
  searchDeliveryOrderWord.value = value;
  deliveryListSearch();
}
const onEnterDeliveryOrderWord = (value) => {
  searchDeliveryOrderWord.value = value;
  deliveryListSearch();
}
const showDeliveryOrderDialog = () => {
  initialParams();
  isDeliveryOrderDialog.value = true;
}
const closeDeliveryOrderDialog = () => {
  isDeliveryOrderDialog.value = false;
}
const callDeliveryBarcord = (item) => {
  isDeliveryOrderLoading.value = true;
  let id = String(deliveryActiveTab.value == 0 ? config.STOCK_TYPES['VAN'] : config.STOCK_TYPES['小分け']);
  id += '_' + String(deliveryActiveTab.value == 0 ? item.wholesaler_id : item.id)
  //小分けの場合はmedicine_group_idも追記する
  if (deliveryActiveTab.value == 1) {
    //-1は渡せないので文字置換する
    id += '_' + (item.medicine_group_id == -1 ? 'outersystem' : String(item.medicine_group_id));
  }
  callDeviceBarcord(config.SPAPP_MENU['納品確認'],id,staffId.value);
}
const isNotEstablishFileExists = ref(false);
const medicineGroupList = reactive([]);
const selectDeliveryConfirmationStock = (item) => {
  if (deliveryActiveTab.value == 1) {
    //開設許可証がアップロードされていない場合はアップロード画面を出す
    if (item.establish_permit_upload_date == null) {
      isNotEstablishFileExists.value = true;
    } else {
      isNotEstablishFileExists.value = false;
    }
    //2つ以上ある場合はグループ選択画面を出す
    if (item.relation_settings.length > 1) {
      //既に既存取引があるので選択させる
      showMedicineGroupSelectDialog(item);
    } else {
      showDeliveryEstablishFileDialog(item);
    }
  } else {
    callDeliveryBarcord(item);
  }
}
const isMedicineGroupDialog = ref(false);
const selectMedicineGroupPharmacy = reactive({});
const showMedicineGroupSelectDialog = (pharmacy) => {
  for (let key in pharmacy) {
    selectMedicineGroupPharmacy[key] = pharmacy[key];
  }
  medicineGroupList.splice(0);
  for (let i=0;i<pharmacy.relation_settings.length;i++) {
    medicineGroupList.push(pharmacy.relation_settings[i]);
  }
  isMedicineGroupDialog.value = true;
}
const closeMedicineGroupSelectDialog = () => {
  isMedicineGroupDialog.value = false;
}
const selectMedicineGroupSelect = (relationSetting) => {
  selectMedicineGroupPharmacy.relation_settings = [relationSetting];
  showDeliveryEstablishFileDialog(selectMedicineGroupPharmacy);
}

watch(deliveryActiveTab,(newValue,oldValue) => {
  searchDeliveryOrderWord.value = '';
  deliveryOrderOptionStockFields.search_word = searchDeliveryOrderWord.value;
  deliveryOrderOptionPackFields.search_word = searchDeliveryOrderWord.value;
});

/////////////////////////
/////////////////////////
const onChangeAuditToday = (value) => {
  appSetting.is_audit_today = value;
  patientListRefresh();
}
///////////////////////////
// 開設許可証アップロード
const selectDeliveryEstablishData = reactive({});
const isDeliveryEstablishFileDialog = ref(false);
const isDeliveryEstablishFileLoading = ref(false);
const deliveryEstablishPermitNumber = ref('');
const deliveryEstablishPermitExpireDate = ref('');
const deliveryEstablishPermitFile = ref(new Object());
const deliveryIsNew = ref(true);
const deliveryTaxTotalType = ref(0);
const deliveryMedicineGroupId = ref(-2);
const deliveryAmountFloatType = ref(0);
const medicineGroupId = ref(-1);
const onDeliveryEstablishPermitFileUpload = (e) => {
  deliveryEstablishPermitFile.value = e.target.files[0];
}
const onChangeDeliveryEstablishPermitNumber = (value) => {
  deliveryEstablishPermitNumber.value = value;
}
const onChangeDeliveryEstablishPermitExpireDate = (value) => {
  deliveryEstablishPermitExpireDate.value = value;
}
const onChangeDeliveryTaxTotalType = (value) => {
  deliveryTaxTotalType.value = value;
}
const onChangeDeliveryAmountFloatType = (value) => {
  deliveryAmountFloatType.value = value;
}
const showDeliveryEstablishFileDialog = (item) => {
  for (let key in item) {
    selectDeliveryEstablishData[key] = item[key];
  }
  deliveryEstablishPermitFile.value = null;
  deliveryTaxTotalType.value = 0;
  deliveryAmountFloatType.value = 0;
  deliveryMedicineGroupId.value = -2;
  if (item.relation_settings.length > 0) {
    deliveryTaxTotalType.value = item.relation_settings[0].tax_total_type;
    deliveryAmountFloatType.value = item.relation_settings[0].amount_float_type;
    deliveryMedicineGroupId.value = item.relation_settings[0].medicine_group_id;
    deliveryIsNew.value = (item.relation_settings[0].is_default == 1 ? true : false);
  }
  //全ての情報が確定済みの場合はこのまま確定処理にする
  if (deliveryIsNew.value == false && isNotEstablishFileExists.value == false) {
    updateDeliveryEstablishFile();
  } else {
    isDeliveryEstablishFileDialog.value = true;
  }
}
const closeDeliveryEstablishFileDialog = () => {
  isDeliveryEstablishFileDialog.value = false;
  //変数初期化
  deliveryEstablishPermitNumber.value = '';
  deliveryEstablishPermitExpireDate.value = '';
  deliveryTaxTotalType.value = 0;
  deliveryIsNew.value = true;
  deliveryAmountFloatType.value = 0;
  deliveryMedicineGroupId.value = -2;
}
const updateDeliveryEstablishFile = async () => {
  if (!selectDeliveryEstablishData.id) {
    errorAlertApp('薬局を選択してください。');
    return;
  }
  let params = new FormData();
  //2024/01/24 TODO 開設許可書の必須条件を削除
  if (isNotEstablishFileExists.value) {
    if ((deliveryEstablishPermitFile.value) ||
        (deliveryEstablishPermitNumber.value) ||
        (deliveryEstablishPermitExpireDate.value)) {
      if (!deliveryEstablishPermitFile.value) {
        errorAlertApp('開設許可証を選択してください。');
        return;
      }
      if (!deliveryEstablishPermitNumber.value) {
        errorAlertApp('開設許可証番号を入力してください。');
        return;
      }
      if (!deliveryEstablishPermitExpireDate.value) {
        errorAlertApp('有効期限を入力してください。');
        return;
      }
      params.append('establish_permit_file',deliveryEstablishPermitFile.value);
      params.append('establish_permit_number',deliveryEstablishPermitNumber.value);
      params.append('establish_permit_expire_date',deliveryEstablishPermitExpireDate.value);
    }
  }
  isDeliveryEstablishFileLoading.value = true;
  params.append('target_pharmacy_id',selectDeliveryEstablishData.id);
  params.append('medicine_group_id',deliveryMedicineGroupId.value);
  params.append('tax_total_type',deliveryTaxTotalType.value);
  params.append('amount_float_type',deliveryAmountFloatType.value);
  params.append('is_new_only',1);

  try {
    const response = await axios(props.apis.pharmacy_relation_setting_update,{method:"post",data:params});
    if (response.data.status == 200) {
      //新規で作成された可能性があるので薬局情報を上書きする
      selectDeliveryEstablishData.id = response.data.data.relation_pharmacy_id;
      selectDeliveryEstablishData.medicine_group_id = response.data.data.reverse_medicine_group_id;
      callDeliveryBarcord(selectDeliveryEstablishData);
    }
  } finally {
    isDeliveryEstablishFileLoading.value = false;
  }
}

////////////////////////////
</script>

<style scoped>
.app-background {
  background-image: url("../spapp/home.png");
  height: 100vh;
  background-repeat: no-repeat;
  padding: 2.0em;
  background-size:cover;
}
.user-area {
  background-color: #F59E12;
  color:white;
  padding:1.2em;
  border-radius: 1.0em;
  box-shadow: 0px 10px 10px -6px rgba(0, 0, 0, 0.3);
}
.menu-area {
  margin-right:1.2em;
  margin-left:1.2em;
}
a.menu-icon {
  display:contents;
  cursor: none;
}
div.menu-icon {
  background-color: white;
  border-radius: 1.0em;
  color:#707070;
  padding:0.8em;
  box-shadow: 0px 10px 10px -6px rgba(0, 0, 0, 0.3);
  width:43%;
  height:16vh
}
div.menu-icon2 {
  background-color: white;
  border-radius: 1.0em;
  color:#707070;
  padding:0.8em 1.8em 1.8em 1.8em;
  box-shadow: 0px 10px 10px -6px rgba(0, 0, 0, 0.3);
  width:43%;
  height:16vh
}
.list-td {
  background-color: #FFF5E0;
  font-size: 1.0em;
  padding: 1.2em;
  border-bottom: 2px solid white;
  border-right: 1px solid #FFF5E0;
  cursor: pointer;
  white-space: normal;
  line-height: 1.7em;
}
.active {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
  --tw-border-opacity: 1;
  border-color: rgb(242 140 31 / var(--tw-border-opacity));
  border-bottom-width: 4px;
}
.active > svg {
  --tw-text-opacity: 1;
  color: rgb(242 140 31 / var(--tw-text-opacity));
}
.address {
  font-size:0.6rem;
}
</style>
<template>
<div ref="element" class="app-background">
  <div class="user-area flex items-center justify-between mb-8">
    <div>{{ user.username }}</div>
    <div>様</div>
  </div>
  <div class="menu-area flex flex-col items-center">
    <div class="w-full flex flex-row items-center justify-between mb-4">
      <a class="menu-icon" href="javascript:void(0)" @click="showStaffDialog(config.SPAPP_MENU['監査チェック'])">
        <div class="menu-icon text-center">
            <img class="m-auto" src="../../../public/spapp/icon/icon_audit_check.svg">
            <span>監査チェック</span>
        </div>
      </a>
      <a class="menu-icon" href="javascript:void(0)" @click="showStaffDialog(config.SPAPP_MENU['納品確認'])">
        <div class="menu-icon text-center">
            <img class="m-auto" src="../../../public/spapp/icon/icon_delivery_confirmation.svg">
            <span>納品確認</span>
        </div>
      </a>
    </div>
    <div class="w-full flex flex-row items-center justify-between mb-4">
      <a class="menu-icon" href="javascript:void(0)" @click="showStaffDialog(config.SPAPP_MENU['発注'])">
        <div class="menu-icon text-center">
            <img class="m-auto" src="../../../public/spapp/icon/icon_order.png">
            <span>発注</span>
        </div>
      </a>
      <a class="menu-icon" href="javascript:void(0)" @click="showStaffDialog(config.SPAPP_MENU['棚卸'])">
        <div class="menu-icon text-center">
            <img class="m-auto" src="../../../public/spapp/icon/icon_stock_control.svg">
            <span>棚卸</span>
        </div>
      </a>
    </div>
    <div class="w-full flex flex-row items-center justify-between mb-4">
      <a class="menu-icon" href="javascript:void(0)" @click="callMenu(config.SPAPP_MENU['履歴'])">
        <div class="menu-icon text-center">
            <img class="m-auto" src="../../../public/spapp/icon/icon_history.svg">
            <span>履歴</span>
        </div>
      </a>
    </div>
    <!--
    <div class="w-full flex flex-row items-center justify-between">
      <a class="menu-icon" href="javascript:void(0)" @click="callMenu(config.SPAPP_MENU['WEB'])">
        <div class="menu-icon text-center">
            <img class="m-auto" src="../../../public/spapp/icon/icon_web.svg">
            <span>WEB</span>
        </div>
      </a>
    </div>
    -->
  </div>
</div>
<modal-app-dialog
  :is-visible="isAuditCheckDialog"
  :close="closeAuditCheckDialog"
  :isLoading="isAuditCheckLoading"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-lg">監査チェックする患者名を選択してください。</div>
    <div class="mb-1">
      <check-box
        label='当日'
        :value="appSetting.is_audit_today"
        :on-change="onChangeAuditToday"
      ></check-box>
    </div>
    <div class="mb-4">
      <search-box
          :search-word="searchPatientWord"
          font-size="1.125rem"
          font-line-height="1.75rem"
          :on-change="onChangePatientWord"
          :on-enter="onEnterPatientWord"
          place-holder="患者名を入力してください。"
      ></search-box>
    </div>
    <div>
      <custom-list
        ref="listPatientRef"
        :table-fields="patientFields"
        :option-fields="patientOptionFields"
        :api-url="apis.pharmacy_prescript_list"
        :is-table-layout-fixed="true"
        font-size="1.2em"
        height="60vh"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in patientFields" :key="index" :style="'width:' + field.width" class="list-td" @click="selectAuditCheckPrescript(slotProps.item.id,slotProps.item.patient_profile.patient_kanji_name,slotProps.item.medical_name)">
          <div v-if="field.field_key == 'real_prescript_date'" :class="field.align">
            {{ slotProps.item.real_prescript_date.split(' ')[0] }}<br>{{ slotProps.item.real_prescript_date.split(' ')[1] }}
          </div>
          <div v-else :class="field.align">
            <span class="font-bold">{{ getFieldValue(slotProps.item,field.field_key) }}</span><br>
            <span class="text-sm">{{ slotProps.item.medical_name }}</span>
          </div>
        </td>
      </template>
      </custom-list>
    </div>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isDeliveryOrderDialog"
  :close="closeDeliveryOrderDialog"
  :isLoading="isDeliveryOrderLoading"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-lg">納品確認する発注先を選択してください。</div>
    <div class="mb-4 text-lg">
      <search-box
          :search-word="searchDeliveryOrderWord"
          font-size="1.125rem"
          font-line-height="1.75rem"
          :on-change="onChangeDeliveryOrderWord"
          :on-enter="onEnterDeliveryOrderWord"
          place-holder="発注先を入力してください。"
      ></search-box>
    </div>
    <div class="w-full mt-1 mb-5">
      <div class="bg-white border-b border-gray-200 dark:border-gray-700">
          <ul class="flex flex-wrap -mb-px text-lg font-medium text-center text-gray-500 dark:text-gray-400">
              <li class="w-1/2" v-for="tab in deliveryActiveTabs" :key="tab.id">
                  <a href="javascript:void(0)" @click="deliveryActiveTab = tab.id" :class="(deliveryActiveTab == tab.id ? 'active ' : '') + 'flex flex-col items-center justify-center pt-2 pb-2 border-b-4 border-gray-300 rounded-t-lg group'">
                      <div>{{ tab.tab_name }}</div>
                  </a>
              </li>
          </ul>
      </div>
    </div>
    <div v-if="deliveryActiveTab == 0">
      <custom-list
        ref="listDeliveryOrderStockRef"
        :table-fields="deliveryOrderFields"
        :option-fields="deliveryOrderOptionStockFields"
        :api-url="apis.pharmacy_current_order_target_list"
        :is-table-layout-fixed="true"
        font-size="1.2em"
        height="52vh"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in deliveryOrderFields" :key="index" :style="'width:' + field.width" class="list-td" @click="selectDeliveryConfirmationStock(slotProps.item)">
          <div :class="field.align">
            <i v-show="slotProps.item.favorite_level == 1" class="fa-solid fa-star text-amber-400 mr-1"></i><span v-html="getFieldValue(slotProps.item,field.field_key)"></span>
          </div>
        </td>
      </template>
      </custom-list>
    </div>
    <div v-else>
      <custom-list
        ref="listDeliveryOrderPackRef"
        :table-fields="deliveryOrderFields"
        :option-fields="deliveryOrderOptionPackFields"
        :api-url="apis.pharmacy_current_order_target_list"
        :is-table-layout-fixed="true"
        font-size="1.2em"
        height="52vh"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in deliveryOrderFields" :key="index" :style="'width:' + field.width" class="list-td" @click="selectDeliveryConfirmationStock(slotProps.item)">
          <div :class="field.align">
            <i v-show="slotProps.item.favorite_level == 1" class="fa-solid fa-star text-amber-400 mr-1"></i><span v-html="getFieldValue(slotProps.item,field.field_key)"></span>
          </div>
        </td>
      </template>
      </custom-list>
    </div>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isStaffDialog"
  :close="closeStaffDialog"
  :isLoading="isStaffLoading"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-sm">スタッフを選択してください。</div>
  </div>
  <div class="overflow-y-auto" style="height:72vh">
    <ul class="border border-gray-200">
      <li v-for="(staff,index) in staffs" :key="index" class="list-td" @click="selectStaff(staff.user_id)">
        {{ staff.user.username }}
      </li>
    </ul>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isMedicineGroupDialog"
  :close="closeMedicineGroupSelectDialog"
>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-sm">取引グループを選択してください。</div>
  </div>
  <div class="overflow-y-auto" style="height:72vh">
    <ul class="border border-gray-200">
      <li v-for="medicineGroup in medicineGroupList" :key="medicineGroup.id" class="list-td" @click="selectMedicineGroupSelect(medicineGroup)">
        {{ medicineGroup.medicine_group_name }}
      </li>
    </ul>
  </div>
  </template>
</modal-app-dialog>

<modal-app-dialog
  :is-visible="isDeliveryEstablishFileDialog"
  :close="closeDeliveryEstablishFileDialog"
  :submit="updateDeliveryEstablishFile"
  cancel-button-name="キャンセル"
  submit-button-name="登録する"
  :isLoading="isDeliveryEstablishFileLoading"
>
  <template v-slot:header>
    小分け情報
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <div v-show="isNotEstablishFileExists">お手元に開設許可証のデータがある場合はアップロードして登録してください。</div>
    <table class="w-full mb-4">
      <tr v-show="isNotEstablishFileExists" class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="file" @change="onDeliveryEstablishPermitFileUpload">
        </td>
      </tr>
      <tr v-show="isNotEstablishFileExists" class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証番号</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <text-box
            type="text"
            font-size="1.125rem"
            font-line-height="1.75rem"
            font-width="half"
            :value="deliveryEstablishPermitNumber"
            :on-change="onChangeDeliveryEstablishPermitNumber"
          ></text-box>
        </td>
      </tr>
      <tr v-show="isNotEstablishFileExists" class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証有効期限</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <text-box
            type="date"
            font-size="1.125rem"
            font-line-height="1.75rem"
            :value="deliveryEstablishPermitExpireDate"
            :on-change="onChangeDeliveryEstablishPermitExpireDate"
          ></text-box>
        </td>
      </tr>
      <tr v-show="deliveryIsNew" class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">合計金額条件</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <select-box
            :value="deliveryTaxTotalType"
            font-size="1.125rem"
            font-line-height="1.75rem"
            :is-searchable="false"
            :options="config.TAX_TOTAL_TYPES"
            :on-change="onChangeDeliveryTaxTotalType"
          ></select-box>
        </td>
      </tr>
      <tr v-show="deliveryIsNew" class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">小数点の扱い</th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <select-box
            :value="deliveryAmountFloatType"
            font-size="1.125rem"
            font-line-height="1.75rem"
            :is-searchable="false"
            :options="config.AMOUNT_FLOAT_TYPES"
            :on-change="onChangeDeliveryAmountFloatType"
          ></select-box>
        </td>
      </tr>
    </table>
  </div>
  </template>
</modal-app-dialog>


</template>

